module.exports = {
  footerText: `Copyright Elsner Technologies  Private Limited © ${new Date().getFullYear()}`,
}
